import { VapeFree } from '@mui/icons-material'
import {
  createSlice,
  createEntityAdapter,
  createAsyncThunk,
  createSelector,
} from '@reduxjs/toolkit'

import {  parse } from 'date-fns'

import invitationService from '../services/invitationService'
import { generatePhoneDetail } from '../utils/phoneUtil'





export const refreshApplications = createAsyncThunk('application/refreshApplications', 
  async () => {
	const response = await invitationService.fetchAll(0)
    return response.data
})


export const fetchAllApplications = createAsyncThunk('application/fetchAllApplications', 
  async (_, {getState}) => {
    const timestamp = selectApplicationTimestamp(getState())
    const response = await invitationService.fetchAll(timestamp)
    return response.data
})

export const fetchApplication = createAsyncThunk('application/fetchApplication', 
  async (id) => {
    const response = await invitationService.fetch(id)
    
    return response.data
})
export const createApplication = createAsyncThunk('application/createApplication', 
  async (application) => {
    const response = await invitationService.create(application)
    return response.data
})
export const updateApplication = createAsyncThunk('application/updateApplication', 
  async (application) => {
    const response = await invitationService.update(application)
    return response.data
})
export const deleteApplication = createAsyncThunk('application/deleteApplication', 
  async (id) => {
    const response = await invitationService.delete(id)
    return response.data
})

export const cancelApplication = createAsyncThunk('application/cancelApplication', 
  async (action) => {
    const response = await invitationService.cancel(action)
    return response.data
})

export const hardDeleteApplication = createAsyncThunk('application/hardDeleteApplication', 
  async (action) => {
    const response = await invitationService.hard_delete(action)
    return response.data
})


export const rescheduleApplicationOnce = createAsyncThunk('application/rescheduleApplicationOnce', 
  async (action) => {
	const response = await invitationService.rescheduleOnce(action)
    return response.data
})
export const rescheduleApplicationWholeSeries = createAsyncThunk('application/rescheduleApplicationWholeSeries', 
  async (action) => {
	const response = await invitationService.rescheduleWholeSeries(action)
    return response.data
})



const maxTimestamp=(list)=>{
  return list.map(x=>x.timestamp ? x.timestamp:10000).reduce( (e,f)=>Math.max(e,f))
}


const addVCols = (x)=>{
  try
  {
    x.formattedStartTm = parse(x.startTm, 'dd/MM/yyyy HH:mm', new Date()).getTime();
    x.formattedEndTm = parse(x.endTm, 'dd/MM/yyyy HH:mm', new Date()).getTime();
    x.timestamp = x.updatedTm ? parse(x.updatedTm, 'dd/MM/yyyy HH:mm:ss', new Date()).getTime(): 1;
    x.invitationVisitors.forEach(element => {
        generatePhoneDetail(element)
      }); 
  }
  catch (ex){
    console.error(ex)
    alert(ex)
  }
  return x
}
const applicationAdapter = createEntityAdapter({
  selectId: (entity) => entity.id,
  
  sortComparer: (a, b) => (b.formattedStartTm - a.formattedStartTm)
})

const initialState = applicationAdapter.getInitialState({
  status: 'idle',
  error: null,
  timestamp: 0,
  lastFetched:0,
  });


const applicationSlice = createSlice({
  name: 'application',
  initialState: initialState,
  reducers: {
    clearApplications(state, action) {
        state.error=null
        state.status='idle'
        applicationAdapter.removeAll(state)
    },
    changePeriod: {
      reducer(state, action) 
      {
        state.period= action.payload
      },
      prepare(newPeriod) {
        return {payload:newPeriod}
      }
    }
  },
  extraReducers(builder) {
    builder
      .addCase(refreshApplications.pending, (state, action) => {
        state.status = 'loading'
        state.error=null
        state.timestamp=0
        state.lastFetched=0
      })  
      .addCase(refreshApplications.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.lastFetched=Date.now();
        if (action.payload && action.payload.length>0) 
        {
            action.payload.forEach( addVCols);
            state.timestamp=maxTimestamp(action.payload)
        }
        else
        {
          state.timestamp=0
        }
        applicationAdapter.setAll(state, action.payload)
      //alert(312300)
      })
      .addCase(refreshApplications.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
    
      .addCase(fetchAllApplications.pending, (state, action) => {
        state.status = 'loading'
        state.error=null
      })
      .addCase(fetchAllApplications.fulfilled, (state, action) => {
          state.status = 'succeeded'
          state.lastFetched=Date.now();
          if (action.payload && action.payload.length>0) 
          {
            action.payload.forEach( addVCols);
            state.timestamp=Math.max( maxTimestamp(action.payload), state.timestamp)
            applicationAdapter.upsertMany(state, action.payload)
          }
        //alert(312300)
      })
      .addCase(fetchAllApplications.rejected, (state, action) => {
        state.status = 'failed'
        state.error = action.error.message
      })
      .addCase(fetchApplication.fulfilled, (state, action) => {
        if (action.payload) 
        {
            let pp = action.payload
            if (!Array.isArray(pp))
            { 
              addVCols(pp, 0)
              applicationAdapter.upsertOne(state, pp)
            }
            else
            {
                pp.forEach( addVCols);
                applicationAdapter.upsertMany(state, pp)
            }
        }
      })
      .addCase(createApplication.fulfilled, (state, action) => {
        if (action.payload) 
        {
            let pp = action.payload
            if (!Array.isArray(pp))
            { 
              addVCols(pp, 0)
              applicationAdapter.addOne(state, pp)
            }
            else
            {
                pp.forEach( addVCols);
                applicationAdapter.addMany(state, pp)
            }
        }
      })
      .addCase(updateApplication.fulfilled, (state, action) => {
        if (action.payload) addVCols(action.payload, 0)
        applicationAdapter.upsertOne(state , action.payload)
      })
      .addCase(deleteApplication.fulfilled, (state, action) => {
        applicationAdapter.removeOne(state,action.payload)
      })
      .addCase(cancelApplication.fulfilled, (state, action) => {
        if (action.payload)
        {   
          action.payload.forEach( addVCols);
          applicationAdapter.upsertMany(state,action.payload)
        }
      })
      .addCase(hardDeleteApplication.fulfilled, (state, action) => {
        if (action.payload)
        {   
          applicationAdapter.removeMany(state,action.payload)
        }
      })
      .addCase(rescheduleApplicationOnce.fulfilled, (state, action) => {
        if (action.payload)
        {   
            let x = action.payload;

            if (x.added && x.added.length>0)
            {
                x.added.forEach( addVCols);
                applicationAdapter.upsertMany(state,x.added)
            }
            if (x.changed && x.changed.length>0)
            {
                x.changed.forEach( addVCols);
                applicationAdapter.upsertMany(state,x.changed)
            }
            if (x.deleted)
            {   
              applicationAdapter.removeMany(state,x.deleted)
            }
        }
      })
      .addCase(rescheduleApplicationWholeSeries.fulfilled, (state, action) => {
        if (action.payload)
        {   
            let x = action.payload;

            if (x.added && x.added.length>0)
            {
                x.added.forEach( addVCols);
                applicationAdapter.upsertMany(state,x.added)
            }
            if (x.changed && x.changed.length>0)
            {
                x.changed.forEach( addVCols);
                applicationAdapter.upsertMany(state,x.changed)
            }
            if (x.deleted)
            {   
              applicationAdapter.removeMany(state,x.deleted)
            }
        }
      })

      

  }
})


export const { clearApplications } = applicationSlice.actions

export default applicationSlice.reducer;

export const {
  selectAll:  selectAllApplications,
  selectById: xselectApplicationById,
  selectIds:  selectApplicationIds,
} = applicationAdapter.getSelectors((state) => state.application)

export const selectApplicationById = (id)=>(state)=>xselectApplicationById(state, id)
export const selectApplicationStatus = (state)=>state.application.status;
export const selectApplicationError = (state)=>state.application.error;
//export const selectApplicationPeriod = (state)=>state.application.period

export const selectApplicationTimestamp = (state)=>state.application.timestamp;
export const selectApplicationLastFetched = (state)=>state.application.lastFetched;



function onlyUnique(value, index, self) {
  return self.indexOf(value) === index;
}


export const selectAllSubjects = 
createSelector(
  [	selectAllApplications],
  (visitors) =>visitors.map(x=>x.reason).filter(onlyUnique).sort()
)



const tofilterApplication= (v, filter)=>
{
  if (!Boolean(filter)) return true;
  let matchStart = !Boolean(filter.start) || v.formattedStartTm>=filter.start.getTime(); 
  let matchEnd = !Boolean(filter.end) || v.formattedStartTm<=filter.end.getTime();
  let matchFloor = !Boolean(filter.floor) || v.floor===filter.floor;
  let matchSubject = !Boolean(filter.subject) || v.reason.toLowerCase().indexOf(filter.subject)>=0;
  return matchStart && matchEnd && matchFloor && matchSubject;
}


export const selectApplicationByFilter = 
createSelector(
  [	selectAllApplications, 	(state, filter)=>filter],
  (apps, fff) =>apps.filter( v=>tofilterApplication(v, fff) ).map(x=>x.id)
)



export const selectApplicationMaxTimespamp = 
createSelector(
  [	selectAllApplications],
  (apps) =>
  {
      if (!apps||apps.length===0 ) return 0;
      return maxTimestamp(apps)
  }
)
